import {
  deriveUnitPrice,
  effectiveAmountOf,
  effectiveInstallationInputsOf,
} from "../../OverviewModal/deriveUnitPrice";
import {
  buildItemTypeSettingsByKey,
  itemTypeSettingKey,
  resolveItemTypeUnit,
} from "../../OverviewModal/resolveItemTypeUnit";
import type {
  InstallationPriceComponent,
  ItemTypePriceComponent,
  MaterialPriceComponent,
} from "../../OverviewModal/useItemTypeSettings";
import type { BuildExportGroupValues } from "./types";

const isMaterialComponent = (
  component: ItemTypePriceComponent,
): component is MaterialPriceComponent => component.factor === "material";

const isInstallationComponent = (
  component: ItemTypePriceComponent,
): component is InstallationPriceComponent =>
  component.factor === "installation";

export const buildExportGroupValues: BuildExportGroupValues = ({
  settings,
  unitLabels,
}) => {
  const settingsByKey = buildItemTypeSettingsByKey({ settings });

  return ({ kind, name }) => {
    const setting = settingsByKey.get(itemTypeSettingKey(kind, name)) ?? null;
    const unit = resolveItemTypeUnit({ kind, setting });
    const priceComponents = setting?.priceComponents ?? [];
    const material = priceComponents.find(isMaterialComponent) ?? null;
    const installation = priceComponents.find(isInstallationComponent) ?? null;
    const installationInputs =
      installation === null
        ? null
        : effectiveInstallationInputsOf(installation);

    return {
      unit: unit === "piece" ? unitLabels.piece : unitLabels.meters,
      materialPrice: material === null ? null : effectiveAmountOf(material),
      hours: installationInputs?.hours ?? null,
      hourlyRate: installationInputs?.hourlyRate ?? null,
      unitPrice: deriveUnitPrice({ priceComponents })?.amount ?? null,
    };
  };
};
